/** @jsx jsx */
/** @jsxRuntime classic */

import { Interpolation, jsx } from '@emotion/react';
import React from 'react';
import { TypographyVariant } from '../style/typography';
import useTheme from '../style/useTheme';
import { ThemeConfig } from '../style/theme';

export type TypographyColor = 'neutral' | 'light';

type Props = React.PropsWithChildren<{
  sx?: React.CSSProperties;
  className?: string;
  ['data-testid']?: string;
  variant?: TypographyVariant;
  href?: string;
  onClick?: () => void;
}>;

const Link: React.FC<Props> = (props) => {
  const {
    sx,
    children,
    variant,
    className,
    'data-testid': dataTestId,
    href,
    onClick,
  } = props;
  const { theme, resolveTypography, resolveColor } = useTheme();

  const css: Interpolation<ThemeConfig> = {
    ...(variant && resolveTypography(variant)),
    margin: 0,
    textDecoration: 'underline',
    cursor: 'pointer',
    color: resolveColor(theme.components.text.link),
    '& > p': {
      color: resolveColor(theme.components.text.link),
    },
    ...sx,
  };

  return (
    <a
      href={href}
      onClick={onClick}
      data-testid={dataTestId}
      className={className}
      css={css}
    >
      {children}
    </a>
  );
};

export default Link;
